export const services_list = [
    { value: 'Filling', label: 'Filling' },
    { value: 'Root Canal therapy', label: 'Root Canal therapy' },
    { value: 'Rot filling', label: 'Rot filling' },
    { value: 'Dental crown', label: 'Dental crown' },
    { value: 'Dental bridge', label: 'Dental bridge' },
    { value: 'Dentures', label: 'Dentures' },
    { value: 'Veneers', label: 'Veneers' },
    { value: 'Implants', label: 'Implants' },
    { value: 'Extraction', label: 'Extraction' },
    { value: 'Teeth Whitening', label: 'Teeth Whitening' },
    { value: 'Braces', label: 'Braces' },
    { value: 'Invisalign', label: 'Invisalign' },
    { value: 'Inlay', label: 'Inlay' },
    { value: 'Composite', label: 'Composite' },
    { value: 'Retainer', label: 'Retainer' },
    { value: 'Sport Guards', label: 'Sport Guards' },
    { value: 'Cleaning', label: 'Cleaning' },
    { value: 'Periodontal therapy', label: 'Periodontal therapy' },
    { value: 'Airflow', label: 'Airflow' },
    { value: 'Periodontal surgery', label: 'Periodontal surgery' },
    { value: 'Surgical extraction', label: 'Surgical extraction' },
  ];
